import React, { useCallback } from 'react';

import { AlertStatus, Link } from '@make-software/cspr-ui';
import { BodyText, Alert } from '@block-explorer/ui';
import { Trans, useTranslation } from 'react-i18next';
import { useWalletService } from '../../services';

export interface ValidateWalletConnectedProps {
  children?: any;
}

export function ValidateWalletConnected({
  children,
}: ValidateWalletConnectedProps) {
  const { t } = useTranslation();
  const walletService = useWalletService();

  const handleSignInClick = () => {
    walletService.connect();
  };

  if (walletService.isLoading) {
    return <>Loading...</>;
  }

  return (
    <>
      {walletService.publicKey == null ? (
        <Alert
          status={AlertStatus.Error}
          message={
            <Trans t={t}>
              <BodyText size={1}>You’re not signed in.</BodyText>{' '}
              <Link
                color="primaryRed"
                onClick={handleSignInClick}
                lineHeight={'xs'}
              >
                Sign in
              </Link>{' '}
              with a compatible wallet like Casper Wallet or Ledger to continue.
            </Trans>
          }
        />
      ) : (
        children
      )}
    </>
  );
}
